import { h, Component, Host, Element } from "@stencil/core";
import { LINK_ICON_POSITION_LEFT } from "../../../constants/global-constants";

@Component({
  tag: "eon-ui-contact-list-item",
  styleUrl: "contact-list-item.scss",
  shadow: false
})
export class ContactListItem {
  @Element() hostElement: HTMLEonUiContactListItemElement;

  componentWillLoad() {
    const child = this.hostElement.children[0];

    if (child.tagName.toLowerCase() === "eon-ui-link") {
      child.setAttribute("align-icon-center", "true");
      child.setAttribute("icon-position", LINK_ICON_POSITION_LEFT);
    }
  }

  render() {
    return (
      <Host>
        <slot />
      </Host>
    );
  }
}
